var _ = require('lodash');
var editorGoals = require('ub/lp/editor/goals');

var _checkIfLightboxPageExists = function(editor, goals) {
  _.forEach(goals, function(goal) {
    var lightboxPage = editor.findPageByRefId(goal.lightboxRefId);

    if ( ! lightboxPage) {
      editor.errorNotifier.captureMessage(
        'Page goal has been set to a missing or deleted lightbox',
        {extra: goal}
      );
    }
  });
};

var _validateLightboxPageGoals = function(editor) {
  var activeGoals = editorGoals.getAllActiveGoals(editor);
  var inactiveGoals = editorGoals.getAllGoals(editor);
  var allGoals = activeGoals.concat(inactiveGoals);

  var lightboxGoals = _.filter(_.uniq(allGoals), function(goal) {
    return goal.type === 'lightbox';
  });

  _checkIfLightboxPageExists(editor, lightboxGoals);
};


module.exports = {
  validateLightboxPageGoals: _validateLightboxPageGoals
};



// WEBPACK FOOTER //
// ./src/control/lightboxGoalValidation.js